export enum GenderTypes {
    male = 'Male',
    female = 'Female',
    nonbinary = 'Nonbinary',
    notsay = 'Prefer not to say',
}